const selectedElement = document.querySelector('.is-selected');

if (selectedElement) {
  const getSelected = selectedElement.dataset.value;
  const getAllSelectorText = document.querySelectorAll('[data-context="alternative"]');

  getAllSelectorText.forEach(selectorText => {
    const selectorTextID = selectorText.id;

    if (getSelected !== selectorTextID) {
      selectorText.classList.add('hidden');
    }
  });
}

const contentColorEdition = document.getElementById('contentColorEdition');
const contentColor = document.getElementById('contentColor');
if (contentColorEdition !== null && contentColor !== null) {
  contentColor.classList.remove('hidden')
}


 /* Bold Update Sold Out button */

 var allRadios = document.querySelectorAll('variant-picker input[type=radio]');

 Array.prototype.forEach.call(allRadios, function(radioSelected) {
    radioSelected.addEventListener('change', changeBoldButton);
});


function changeBoldButton(event){
  event.preventDefault()
  setTimeout(() => {    
    if (document.querySelector('buy-buttons .button.bold_hidden') != null){
      if (document.querySelector('buy-buttons .button.bold_hidden').hasAttribute('disabled')){
        document.querySelector('buy-buttons .button.bold_clone').setAttribute('disabled',true)
        document.querySelector('buy-buttons .button.bold_clone div div').innerHTML = 'Sold out'
      } else {
        document.querySelector('buy-buttons .button.bold_clone').removeAttribute('disabled')
        document.querySelector('buy-buttons .button.bold_clone div div').innerHTML = 'Add to cart'
      }
    }
  }, 10);
}


setTimeout(() => {
  if (document.querySelector('.bold_clone') != null){
    document.querySelector('product-quick-add').style.display = 'none'
  }
}, 100);